<template>
  <div v-loading="loading" class="select-people">
    <ul class="select-list">
      <li v-for="(item, index) in selected" :key="index">
        <div class="type">
          <template v-if="['user', 'superior'].includes(item.type)">
            人员
          </template>
          <template v-else-if="item.type.includes('role')">
            角色
          </template>
          <template v-else-if="item.type.includes('mail')">
            邮箱
          </template>
        </div>
        <div class="arrow1"></div>
        <div class="label">{{ item.label }}</div>
        <template
          v-if="
            dataRange.includes('staffStructure') &&
              !['role', 'mail', 'app_role'].includes(item.type)
          "
        >
          <base-dropdown
            ref="baseDropdown"
            margin-top="6"
            placement="bottom-start"
            width="160"
            :key="index"
          >
            <div slot="reference">
              <div v-if="item.type != 'user'" class="structure">
                <template>
                  上级
                  <i class="el-icon-arrow-down"></i>
                </template>
              </div>
              <el-tooltip v-else content="使用人员的组织关系">
                <span class="icon-more">
                  <i class="el-icon-more"></i>
                </span>
              </el-tooltip>
            </div>
            <div class="structure-dropdown">
              <ul>
                <li @click="setStructure(item, index, 'superior')">上级</li>
              </ul>
              <ul>
                <li @click="setStructure(item, index)">移除</li>
              </ul>
            </div>
          </base-dropdown>
        </template>
        <el-tooltip content="删除">
          <span @click="deleteSelect(index)" class="icon-delete">
            <i class="el-icon-close"></i>
          </span>
        </el-tooltip>
      </li>
    </ul>
    <!--   邮箱-->
    <ul class="select-list">
      <li v-for="(i, dex) in mails" :key="dex">
        <div class="type">
          邮箱
        </div>
        <div class="arrow1"></div>
        <div class="label">{{ i }}</div>
        <el-tooltip content="删除">
          <span @click="deleteMail(i)" class="icon-delete">
            <i class="el-icon-close"></i>
          </span>
        </el-tooltip>
      </li>
    </ul>
    <dropdown-menu
      v-show="canAdd"
      :display-text="displayText"
      @command="handleMenuSelect"
      :data-range="dataRange"
      :people-variables="peopleGroup"
    ></dropdown-menu>
    <select-dialog
      type="role"
      :visible.sync="selectVisible"
      :selected="selected"
      :select-list="selectList"
      :multiple="multiple"
      @select="handleDialogSelect"
    ></select-dialog>
    <select-user-dialog
      :multiple="multiple"
      ref="userSelectDialog"
      @select-user="handleDialogSelect"
    ></select-user-dialog>
    <select-mail-dialog
      :visible.sync="selectMailVisible"
      ref="mailSelectDialog"
      :mail-list="mails"
      @input="handleMailDialog"
    ></select-mail-dialog>
  </div>
</template>

<script>
// api
import { getRoles } from "@/api/appManage/role"
import { getAllProjectRole } from "@/api/project/project"
// components
import DropdownMenu from "./DropdownMenu"
import SelectDialog from "./SelectDialog"
import SelectMailDialog from "./SelectMailDialog"
import BaseDropdown from "@/components/UIComponents/Dropdown"
import { getVarType } from "@/utils/common"
import SelectUserDialog from "@/components/SelectUserDialog"
import { getCompanyRolesWithNum, getCompanyUsers } from "@/api/userCenter/company"

export default {
  name: "select-people",
  components: {
    DropdownMenu,
    SelectDialog,
    BaseDropdown,
    SelectUserDialog,
    SelectMailDialog
  },
  props: {
    value: {
      required: true
    },
    from: {
      type: String,
      default: "Company",
      validator(value) {
        return ["Company", "Project", "App"].indexOf(value) !== -1
      }
    },
    appId: String,
    projectId: String,
    dataRange: {
      type: Array,
      // user: 员工，role: 角色，staffStructure: 员工结构
      default: () => ["user", "role", "staffStructure"]
    },
    displayText: {
      type: Object,
      default: () => ({
        addBtn: "添加人员",
        addRole: "选择角色",
        addUser: "选择人员",
        addMail: "添加邮箱"
      })
    },
    mailList: Array,
    multiple: Boolean,
    peopleGroup: Array,
    emailDefs: Array
  },
  data() {
    return {
      ignoreUpdate: false,
      roles: null,
      selectVisible: false,
      selectMailVisible: false,
      selectList: [],
      mails: [],
      dialogType: "user", // ["user", "role"]
      selected: [],
      rolePromise: null,
      userPromise: null,
      curCompanyUsers: []
    }
  },
  computed: {
    loading() {
      return this.roles === null
    },
    usersMap() {
      let map = this._.keyBy(
        this.curCompanyUsers.map(u => ((u.label = u.name), u)),
        "id"
      )
      this.peopleGroup.forEach(group => {
        if (group.options?.length) {
          group.options.forEach(i => (map[i.value] = i))
        }
      }, {})
      return map
    },
    rolesMap() {
      return this._.keyBy(this.roles || [], "value")
    },
    canAdd() {
      if (this.multiple) return true
      if (this.selected.length > 0) return false
      return true
    },
    selectedUsers() {
      return this.selected
        .filter(t => t.type === "user" && /^([0-9]|[a-z]){24}$/.test(t.code)) // 过滤出所有是普通用户的选项
        .map(t => ({ label: t.label, value: t.code }))
    }
  },
  watch: {
    value(newVal) {
      if (this.ignoreUpdate) {
        this.ignoreUpdate = false
        return
      }
      this.init()
    }
  },
  created() {
    if (this.multiple && !Array.isArray(this.value)) {
      this.$emit("input", [])
    }
    if (!this.multiple && Array.isArray(this.value)) {
      this.$emit("input", "")
    }
    this.rolePromise = this.initRoles()
    this.userPromise = getCompanyUsers().then(users => (this.curCompanyUsers = users))
  },
  methods: {
    init() {
      this.mails = this.mailList
      Promise.all([this.rolePromise, this.userPromise]).then(() => {
        this.setSelected()
      })
    },
    setSelected() {
      let result = []
      if (!this.value?.length) {
        this.selected = result
        return
      }
      let list = [].concat(this.value)
      list.forEach(item => {
        if (getVarType(item) === "Object") {
          if (["user", "superior"].includes(item.type)) {
            if (this.usersMap[item.code]) {
              result.push({
                code: item.code,
                type: item.type,
                label: this.usersMap[item.code].label
              })
            }
          } else if (item.type.includes("role")) {
            if (this.rolesMap[item.code]) {
              result.push({
                code: item.code,
                type: item.type,
                label: this.rolesMap[item.code].label
              })
            }
          } else if (item.type.includes("mail")) {
            result.push({
              code: item.code,
              type: item.type,
              label: item.label
            })
          }
        } else if (getVarType(item) === "String") {
          if (this.usersMap[item]) {
            result.push({
              code: item,
              type: "user",
              label: this.usersMap[item].label
            })
          }
        }
      })
      this.selected = result
      this.ignoreUpdate = true
      this.emitValue()
    },
    initRoles() {
      let request = null
      switch (this.from) {
        case "Company":
          request = getCompanyRolesWithNum()
          break
        case "Project":
          request = getAllProjectRole(this.projectId)
          break
        case "App":
          request = getRoles({ appId: this.appId })
          break
      }
      if (!request) return Promise.reject()
      return request.then(roles => {
        this.roles = roles.map(i => ({ label: i.name, value: i.id }))
        return this.roles
      })
    },
    handleMenuSelect(command, item) {
      switch (command) {
        case "open-role-dialog": {
          this.dialogType = "role"
          this.selectList = this.roles
          this.selectVisible = true
          break
        }
        case "open-user-dialog": {
          this.dialogType = "user"
          this.$refs.userSelectDialog?.open(this.selectedUsers.map(u => u.value))
          break
        }
        case "open-mail-dialog": {
          this.selectMailVisible = true
          this.$refs.mailSelectDialog?.open()
          break
        }
        case "select-variable": {
          this.addSelect({
            code: item.value,
            type: item.isMail ? "mail" : "user",
            label: item.label
          })
          break
        }
      }
    },
    addSelect(newItems) {
      newItems = [].concat(newItems)
      if (newItems.length == 0) return
      let newSelect = []
      for (let item of newItems) {
        if (this.selected.find(i => i.code == item.code)) continue
        newSelect.push(item)
      }
      this.selected = this.selected.concat(newSelect)
      this.emitValue()
    },
    deleteSelect(index) {
      this.selected.splice(index, 1)
      this.emitValue()
    },
    handleMailDialog(emails) {
      this.mails = emails.split(",")
      this.$emit("addMail", emails.split(","))
    },
    deleteMail(mail) {
      this.mails = this.mails.filter(item => item !== mail)
      this.$emit("addMail", this.mails)
    },
    handleDialogSelect(value) {
      let list = [].concat(value)
      if (list.length == 0) return
      if (this.dialogType == "role") {
        let map = {
          Project: "project_role",
          Company: "company_role",
          App: "app_role"
        }
        let valueType = map[this.from]
        if (!valueType) return
        for (let item of list) {
          this.selected.push({
            code: item.value,
            type: valueType,
            label: item.label
          })
        }
      } else if (this.dialogType == "user") {
        for (let item of list) {
          if (!this.selected.find(t => t.code === item.id)) {
            this.selected.push({
              code: item.id,
              type: "user",
              label: item.name
            })
          }
        }
      }
      this.emitValue()
    },
    emitValue() {
      this.$emit("input", this.selected)
    },
    setStructure(user, index, structure) {
      if (!structure) user.type = "user"
      else user.type = structure
      let component = this.$refs.baseDropdown.find(i => i.$vnode.key == index)
      component?.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.select-people {
  .select-list {
    li {
      display: flex;
      font-size: 12px;
      margin-bottom: 6px;
      &:hover {
        .icon-delete {
          display: block;
        }
      }
      .type {
        padding: 0 5px 0 12px;
        background-color: #f5f5f5;
        height: 28px;
        line-height: 28px;
        box-sizing: border-box;
        border: 1px solid #ddd;
        border-radius: 26px 0 0 26px;
        border-right-width: 0;
        color: #333;
        font-weight: bold;
      }
      .arrow1 {
        width: 0;
        height: 0;
        margin-left: 0;
        border-color: #01ca83 #01ca83 #01ca83 #f5f5f5;
        border-style: solid;
        border-width: 14px 7px;
      }
      .label {
        @include ellipsis;
        z-index: 2;
        border-radius: 0 26px 26px 0;
        padding-right: 12px;
        height: 28px;
        line-height: 28px;
        max-width: 220px;
        box-sizing: border-box;
        background: #01ca83;
        color: #fff;
      }
      .structure {
        padding: 0 10px 0 19px;
        height: 28px;
        line-height: 28px;
        background: #4c7d9e;
        border-radius: 0 28px 28px 0;
        color: #fff;
        position: relative;
        cursor: pointer;
        &::before {
          content: "";
          position: absolute;
          top: -2px;
          left: -7px;
          width: 16px;
          height: 32px;
          background: #fff;
          border-radius: 0 32px 32px 0;
        }
        i {
          margin-left: 4px;
        }
      }
      .icon-more {
        width: 28px;
        height: 28px;
        display: block;
        font-size: 16px;
        border-radius: 50%;
        background: #f4f4f4;
        color: #9d9d9d;
        margin-left: 5px;
        line-height: 28px;
        text-align: center;
        cursor: pointer;
      }
      .icon-delete {
        margin-left: 5px;
        color: #ddd;
        font-size: 18px;
        line-height: 28px;
        font-weight: bold;
        cursor: pointer;
        display: none;
        &:hover {
          color: #f44336;
        }
      }
    }
  }
}
.structure-dropdown {
  ul {
    padding: 6px 0;
    &:not(:first-child) {
      border-top: 1px solid #ddd;
    }
    li {
      height: 32px;
      line-height: 32px;
      cursor: pointer;
      // vertical-align: middle;
      box-sizing: border-box;
      padding: 0 16px;
      &:hover {
        background-color: $color-main;
        color: #fff;
      }
    }
  }
}
</style>
